module.exports = __webpack_public_path__ + "static/extension-warning-c0d6fe0ab906f11e65365f8a7784a70e.png";